/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import {
  Row,
  Col,
  AntdLayout,
  Card,
  Typography,
  Form,
  Input,
  Button,
  Checkbox,
  useForm,
} from '@pankod/refine-antd';
import './style.css';

import { useLogin } from '@pankod/refine-core';
import type { HttpError } from '@pankod/refine-core';

const { Title } = Typography;

interface FormProps {
  email: string;
  password: string;
  remember: boolean;
}

const Login: React.FC = () => {
  const { formProps } = useForm<FormProps, HttpError, FormProps>({
    metaData: {
      fields: ['email', 'password'],
    },
  });

  const { mutate: login, isLoading } = useLogin<FormProps>();

  const CardTitle = (
    <Title level={3} className='title'>
      Sign in your account
    </Title>
  );

  return (
    <AntdLayout className='layout'>
      <Row
        justify='center'
        align='middle'
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <div className='container'>
            <div className='imageContainer'>
              <img src='/assets/logo.svg' alt='ebridge Logo' />
            </div>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }}>
              <Form
                {...formProps}
                layout='vertical'
                onFinish={(values) => {
                  login(values);
                }}
                requiredMark={false}
                initialValues={{
                  remember: false,
                  email: '',
                  password: '',
                }}
              >
                <Form.Item
                  name='email'
                  label='Email'
                  rules={[{ required: true, type: 'email' }]}
                >
                  <Input size='large' placeholder='Email' />
                </Form.Item>
                <Form.Item
                  name='password'
                  label='Password'
                  rules={[{ required: true }]}
                  style={{ marginBottom: '12px' }}
                >
                  <Input type='password' placeholder='●●●●●●●●' size='large' />
                </Form.Item>
                <div style={{ marginBottom: '12px' }}>
                  <Form.Item name='remember' valuePropName='checked' noStyle>
                    <Checkbox
                      style={{
                        fontSize: '12px',
                      }}
                    >
                      Remember me
                    </Checkbox>
                  </Form.Item>
                </div>
                <Button
                  type='primary'
                  size='large'
                  htmlType='submit'
                  block
                  loading={isLoading}
                >
                  Sign in
                </Button>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  );
};

export default Login;
